











































import { computed, defineComponent } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'UtilList',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hasComment: {
      type: Boolean,
      default: true,
    },
    hasEdit: {
      type: Boolean,
      default: true,
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = sl.get('store');

    const hasCommentPermission = computed(() =>
      store.hasPermission('ADD_COMMENTS')
    );

    const canViewMenu = computed(
      () =>
        (hasCommentPermission.value && props.hasComment) ||
        props.hasEdit ||
        props.hasDelete
    );
    return { hasCommentPermission, canViewMenu };
  },
});
